import dayjs from 'dayjs'
import ApiService from './ApiService'

export const getVendorStats = (id) =>
    ApiService.get(`/vendor/vendor-stats/${id}/`)

export const getInvoiceStats = (id) =>
    ApiService.get(`/invoice/invoice-stats/${id}/`)

export const getInvoiceCount = (data) => {
    const datas = {}
    if (data?.company) {
        datas.company = data?.company
    }
    if (data?.client) {
        datas.client = data?.client
    }
    if (data?.vendor) {
        datas.transport_provider = data?.vendor
    }
    return ApiService.get('/dashboard/invoice-count-stats/', datas)
}

export const getInvoiceVarrience = (data) => {
    const datas = {}
    if (data?.company) {
        datas.company = data?.company
    }
    if (data?.client) {
        datas.client = data?.client
    }
    if (data?.vendor) {
        datas.transport_provider = data?.vendor
    }
    return ApiService.get('/dashboard/invoice-variance-stats/', datas)
}

export const getInvoiceTotal = (data) => {
    const datas = {}
    if (data?.company) {
        datas.company = data?.company
    }
    if (data?.client) {
        datas.client = data?.client
    }
    if (data?.vendor) {
        datas.transport_provider = data?.vendor
    }
    return ApiService.get('/dashboard/invoice-total-stats/', datas)
}

export const getVendorReport = (data) => {
    const datas = {}
    if (data?.company) {
        datas.company = data?.company
    }
    if (data?.client) {
        datas.client = data?.client
    }
    if (data?.vendor) {
        datas.transport_provider = data?.vendor
    }
    if (data?.start_date) {
        datas.start_date = data?.start_date
    }
    if (data?.end_date) {
        datas.end_date = data?.end_date
    }
    return ApiService.get('/dashboard/invoice-total-variance-stats/', datas)
}

export const getPerformer = (data) => {
    const datas = { type: data.type }
    if (data?.company) {
        datas.company_id = data?.company
    }
    if (data?.client) {
        datas.client = data?.client
    }
    if (data?.vendor) {
        datas.transport_provider = data?.vendor
    }
    return ApiService.get('/dashboard/top-or-under-performer/', datas)
}

export const getUserUsageDataApi = (data) => {
    const datas = {}
    if (data?.company) {
        datas.company_id = data?.company
    }
    if (data?.client) {
        datas.client = data?.client
    }
    if (data?.vendor) {
        datas.transport_provider = data?.vendor
    }
    return ApiService.get(`/dashboard/usage-tracker/`, datas)
}

export const getCompanyUsageDataApi = (data) => {
    const datas = {}
    if (data?.company) {
        datas.company_id = data?.company
    }
    if (data?.client) {
        datas.client = data?.client
    }
    if (data?.vendor) {
        datas.transport_provider = data?.vendor
    }
    return ApiService.get(`/dashboard/company-usage-tracker/`, datas)
}

export const getCostPerKgDataApi = (data) => {
    const datas = {}
    if (data?.company) {
        datas.company_id = data?.company
    }
    if (data?.invoice) {
        datas.invoice_id = data?.invoice
    }
    return ApiService.get(`/dashboard/cost-per-kg/`, datas)
}

export const getServiceChargeSummaryDataApi = (data) => {
    const datas = {}
    if (data?.company) {
        datas.company_id = data?.company
    }
    if (data?.invoice) {
        datas.invoice_id = data?.invoice
    }
    return ApiService.get(`/dashboard/service-charge-summary/`, datas)
}

export const getSurchargesDataApi = (data) => {
    const datas = {}
    if (data?.company) {
        datas.company_id = data?.company
    }
    if (data?.invoice) {
        datas.invoice_id = data?.invoice
    }
    return ApiService.get(`/dashboard/top-surcharges/`, datas)
}

export const getCombinedDataApi = (data) => {
    const datas = {}
    if (data?.company) {
        datas.company_id = data?.company
    }
    if (data?.startdate) {
        datas.start_date = data?.startdate
    } else {
        datas.month = dayjs().format('YYYY-MM')
    }
    if (data?.enddate) {
        datas.end_date = data?.enddate
    }
    return ApiService.get(`/dashboard/combined-invoice-metrics/`, datas)
}
